import React, { useRef } from "react";
import { formatDate, formatMoney } from "../Helpers";
import { FaDownload } from "react-icons/fa";

export default function PaymentReceipt({ paymentData }) {
  const receiptRef = useRef();
  const receiptId = paymentData?.uuid?.split("-")?.[0]?.toUpperCase() || "N/A";

  const handleDownloadPDF = async () => {
    const html2pdf = (await import("html2pdf.js")).default;
    const element = receiptRef.current;

    const opt = {
      margin: 0.5,
      filename: `Payment_Receipt_${receiptId}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };

    html2pdf().set(opt).from(element).save();
  };

  return (
    <div className="mx-auto" style={{ width: "600px", maxWidth: "100%" }}>
      <div className="d-flex justify-content-end gap-2 mb-3 data-html2pdf-ignore no-print">
        <button
          onClick={handleDownloadPDF}
          className="btn btn-sm btn-dark d-flex align-items-center gap-2 rounded-pill px-3 py-2 fw-semibold"
        >
          <FaDownload size={16} />
          Download PDF
        </button>
      </div>

      <div
        ref={receiptRef}
        className="bg-white p-5 border-0 shadow-lg position-relative"
        style={{ fontFamily: "'Inter', sans-serif" }}
      >
        <div
          className="position-absolute top-0 start-0 w-100"
          style={{ height: "6px", background: "linear-gradient(90deg, #0f172a, #334155, #0f172a)" }}
        />

        <div className="text-center mb-5">
          <h2 className="fw-bolder m-0" style={{ letterSpacing: "-1px", color: "#1e293b" }}>
            BOB MAPIKIPIKI
          </h2>
          <p className="text-uppercase small fw-bold mb-2" style={{ letterSpacing: "2px", color: "#64748b" }}>
            Official Payment Receipt
          </p>
        </div>

        <div className="row g-3 mb-4">
          <div className="col-6">
            <div className="h-100 p-3 rounded-3" style={{ backgroundColor: "#f8fafc", border: "1px solid #e2e8f0" }}>
              <small className="text-uppercase d-block mb-1" style={{ letterSpacing: "1.5px", color: "#64748b" }}>
                Customer
              </small>
              <strong style={{ color: "#0f172a" }}>{paymentData?.fullname || "Not provided"}</strong>
            </div>
          </div>
          <div className="col-6">
            <div className="h-100 p-3 rounded-3" style={{ backgroundColor: "#f8fafc", border: "1px solid #e2e8f0" }}>
              <small className="text-uppercase d-block mb-1" style={{ letterSpacing: "1.5px", color: "#64748b" }}>
                Receipt ID
              </small>
              <strong style={{ color: "#0f172a" }}>{receiptId}</strong>
            </div>
          </div>
        </div>

        <div className="rounded-3 mb-5" style={{ border: "1px solid #e2e8f0", overflow: "hidden" }}>
          <div className="px-4 py-3 border-bottom" style={{ backgroundColor: "#f8fafc" }}>
            <h6 className="mb-0 fw-bold" style={{ color: "#0f172a" }}>
              Payment Details
            </h6>
          </div>
          <div className="px-4 py-2">
            {[
              { label: "Customer", value: paymentData?.fullname || "Not provided" },
              { label: "Phone", value: paymentData?.phone || "Not provided" },
              { label: "Motorcycle", value: paymentData?.model || "Not provided" },
              { label: "Amount Paid", value: formatMoney(paymentData?.amount || 0) },
              { label: "Debt Total", value: formatMoney(paymentData?.totalAmount || 0) },
              { label: "Remaining Balance", value: formatMoney(paymentData?.balance || 0) },
              { label: "Payment Date", value: paymentData?.dateCreated ? formatDate(paymentData.dateCreated) : "Not set" },
            ].map((item) => (
              <div
                key={item.label}
                className="d-flex justify-content-between align-items-start gap-3 py-3 border-bottom"
                style={{ borderColor: "#e2e8f0" }}
              >
                <span className="small text-uppercase fw-semibold" style={{ letterSpacing: "1px", color: "#64748b" }}>
                  {item.label}
                </span>
                <strong className="text-end" style={{ color: "#0f172a" }}>
                  {item.value}
                </strong>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-5 text-center">
          <p className="small text-muted mb-1">
            Authorized By: <strong>{paymentData?.issuedByName || "System"}</strong>
          </p>
          <p className="small text-muted mb-0">&copy; {new Date().getFullYear()} BOB MAPIKIPIKI.</p>
        </div>
      </div>
    </div>
  );
}
